import type { CSSProperties } from "react";

type IconProps = {
  style?: CSSProperties;
  className?: string;
};

const svgProps = {
  viewBox: "0 0 24 24",
  width: "1em" as const,
  height: "1em" as const,
  fill: "none" as const,
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true as const,
};

/** Lucide-style plane (clean stroke icon). */
export const PlaneIcon = ({ style, className }: IconProps) => (
  <svg {...svgProps} className={className} style={style}>
    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
  </svg>
);

/** Lucide-style cargo ship. */
export const CargoShipIcon = ({ style, className }: IconProps) => (
  <svg {...svgProps} className={className} style={style}>
    <path d="M12 10.189V14" />
    <path d="M12 2v3" />
    <path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6" />
    <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76" />
    <path d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.5 0 2.5 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
  </svg>
);
